import { forwardRef, InputHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

type TextAreaProps = InputHTMLAttributes<HTMLTextAreaElement>;

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { className = '', ...props }: TextAreaProps,
  ref
) {
  return (
    <textarea
      ref={ref}
      className={twMerge('textarea textarea-bordered bg-base-300', className)}
      {...props}
    />
  );
});
